export default __webpack_public_path__ + "static/media/understanding-the-moon.b8f08173.jpg";